import React from "react";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";

export const Main = ({ children, subHeading = false, noPadding, ...props }) => {
  return (
    !!children && (
      <MainWrapper as="main" {...props}>
        <MainContainer noPadding={noPadding}>
          {subHeading && <Subheading>{ReactHtmlParser(subHeading)}</Subheading>}
          {children}
        </MainContainer>
      </MainWrapper>
    )
  );
};

const MainWrapper = styled.div`
  background: #ffffff;
  color: #505050;
  display: flex;
  flex: 1;
`;

const MainContainer = styled.div`
  display: flex;
  padding: 15px;
  width: 100%;
  background: #102b4e;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: ${(props) => (props.noPadding ? 0 : "0 0 0 15px")};
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: ${(props) => (props.noPadding ? 0 : "0 0 0 40px")};
  }
`;

const Subheading = styled.div`
  color: #0065c3;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 24px 0;
  text-align: center;
  text-transform: uppercase;
  width: 100%;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 32px;
    margin: 0 0 32px 0;
  }
`;
